import { makeStyles } from '@material-ui/core';
import * as colours from '../../../abstracts/colours';
import constants from '../../../abstracts/constants';

interface StyleProps {
  errorMsg: string;
}

const useStyles = makeStyles({
  input: {
    '&.MuiOutlinedInput-root.MuiOutlinedInput-adornedEnd': {
      paddingRight: '16px',
    },
    '&, & .MuiOutlinedInput-input': {
      cursor: 'pointer',
      fontFamily: constants.sourceSansPro,
      fontSize: 20,
    },
    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& .MuiIconButton-root': {
      padding: 0,
    },
    '& .MuiIconButton-label': {
      height: '16px',
      width: '16px',
    },
    '& .Mui-disabled .MuiInputBase-input': {
      color: colours.xanadu,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.iron,
      borderWidth: 2,
      borderRadius: 10,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.scienceBlue,
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.scienceBlue,
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.iron,
      backgroundColor: colours.silverTwo,
      opacity: 0.15,
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.cherry,
    },
    '&:hover.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.cherry,
    },
  },
  endAdornment: {
    cursor: 'pointer',
    color: colours.scienceBlue,
    fontFamily: constants.sourceSansPro,
    display: 'flex',
    flexDirection: 'column',
    '& button:first-child': {
      marginBottom: '2px',
    },
    '& .MuiButtonBase-root:hover': {
      backgroundColor: colours.seashell,
    },
  },
  helperText: {
    display: 'inline-block',
    fontFamily: constants.sourceSansPro,
    marginTop: 0,
    letterSpacing: 'normal',
    color: (props: StyleProps) => (props.errorMsg ? colours.cherry : colours.abbey),
    marginLeft: '16px',
    marginRight: '16px',
    fontSize: '0.75rem',
  },
  label: {
    color: colours.black,
    fontFamily: constants.sourceSansPro,
    fontSize: '20px',
    marginLeft: '16px',
    lineHeight: 1.5,
  },
});

export default useStyles;
